import { render, staticRenderFns } from "./AssessmentScore.vue?vue&type=template&id=f60ff584&scoped=true"
import script from "./AssessmentScore.vue?vue&type=script&lang=js"
export * from "./AssessmentScore.vue?vue&type=script&lang=js"
import style0 from "./AssessmentScore.vue?vue&type=style&index=0&id=f60ff584&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f60ff584",
  null
  
)

export default component.exports